



























































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ProcessDialog extends Vue {
  private visible: any = false;
  private title: any = '';
  private type: any = '';
  private groupName: any = '';
  private data: any = '';

  private options: any = [
    {
      label: '分组1',
      value: 1,
    },
    {
      label: '分组2',
      value: 2,
    },
  ];

  /**
   * 打开窗口
   */
  private async showDialog(title: any, type: any, data: any) {
    this.title = title;
    this.type = type;
    this.visible = true;
    this.data = data;
    if (type === 'update') {
      this.groupName = data.name;
    }
  }

  /**
   * 关闭窗口
   */
  private hideDialog() {
    this.close();
  }

  /**
   * 【表单】弹窗关闭
   */
  private close() {
    this.visible = false;
    this.groupName = '';
  }

  private save() {
    this.$emit('on-response', this.groupName, this.type, this.data);
    this.close();
  }
}
